import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/hand-lizard': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M556.7 290.5L410.3 64.8C397 44.3 374.4 32 349.9 32H56C25.1 32 0 57.1 0 88V96C0 140.1 35.9 176 80 176H276L257.7 224H144C95.5 224 56 263.5 56 312 56 342.9 81.1 368 112 368H243.6C246.5 368 249.5 368.5 252.2 369.6L352 408.4V480H576V355.8C576 332.6 569.3 310 556.7 290.5zM528 432H400V408.4C400 388.5 388 370.9 369.4 363.7L269.6 324.9A71.7-71.7 0 0 1 243.6 320H112C107.6 320 104 316.4 104 312 104 289.9 121.9 272 144 272H257.7C277.5 272 295.5 259.6 302.5 241.1L327.1 176.8C336.1 153.3 318.7 128 293.5 128H80C62.4 128 48 113.6 48 96V88C48 83.6 51.6 80 56 80H349.9C358.1 80 365.6 84.1 370.1 90.9L516.4 316.7A71.8-71.8 0 0 0 528 355.8V432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/hand-lizard.js
// module id = lyLl
// module chunks = 144